import 'babel-polyfill'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins'
import filters from 'filters'
import '@/assets/styles/index.scss'
import 'flex.css'
import VueClipboard from 'vue-clipboard2'
import eventRegister from '@/mixins/routerPagePath.js'
import { getStack } from '@/untils/routerPageStack.js'
import VueQuillEditor from 'vue-quill-editor'
// VueQuillEditor styles 富文本
import 'quill/dist/quill.snow.css'
import moment from 'moment'
// 手动引入所需要的语言包
import 'moment/locale/zh-cn'
import { getRandomString } from '@/untils/util'

moment.locale('zh-cn')

Vue.use(VueQuillEditor)
Vue.use(VueClipboard)

eventRegister(router)

Vue.prototype.$pageStack = { getStack }

Vue.config.productionTip = false

/**
 * 随机生成TraceId用于上报日志
 */
let TraceId = getRandomString()
localStorage.setItem('TraceId', TraceId)
/**
 * 随机生成ClientSession用于上报日志
 */
let ClientSession = getRandomString()
localStorage.setItem('ClientSession', ClientSession)

// 注册全局过滤器
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
